import { Component, Host, h, Prop, Event } from '@stencil/core';
export class DialogHeader {
  constructor() {
    /**
     * Defines if the dialog close button will be displayed.
     */
    this.hideCloseButton = false;
  }
  render() {
    return (h(Host, null,
      h("div", { class: "sy-dialog-title" }, this.dialogTitle ? this.dialogTitle : h("slot", null)),
      !this.hideCloseButton && h("sy-dismiss", { class: "sy-dismiss", large: true, onClick: () => this.syDialogHeaderDidCloseClick.emit() })));
  }
  static get is() { return "sy-dialog-header"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "dialogTitle": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Title to be displayed in the dialog."
      },
      "attribute": "dialog-title",
      "reflect": false
    },
    "hideCloseButton": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines if the dialog close button will be displayed."
      },
      "attribute": "hide-close-button",
      "reflect": true,
      "defaultValue": "false"
    }
  }; }
  static get events() { return [{
      "method": "syDialogHeaderDidCloseClick",
      "name": "syDialogHeaderDidCloseClick",
      "bubbles": false,
      "cancelable": false,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Event to indicate the click on the dialog-header close button."
      },
      "complexType": {
        "original": "void",
        "resolved": "void",
        "references": {}
      }
    }]; }
}
